import { render, staticRenderFns } from "./CardapioProdutos.vue?vue&type=template&id=3dc28ef9&scoped=true"
import script from "./CardapioProdutos.vue?vue&type=script&lang=js"
export * from "./CardapioProdutos.vue?vue&type=script&lang=js"
import style0 from "./CardapioProdutos.vue?vue&type=style&index=0&id=3dc28ef9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc28ef9",
  null
  
)

export default component.exports